import {AsyncActDecorator} from '@gongxigames/framework/slotV2/fsm/acts/decorators/AsyncActDecorator';
import {SlotSettings} from '@gongxigames/framework/slot';

export class PlayOddsUpfrontAct extends AsyncActDecorator {
    public async execute(): Promise<void> {
        if ((this.settings as SlotSettings).get('showOddsUpfront')) {
            await this.emitter.emitAsync('General.Game.PLAY_ODDS_UPFRONT');
        }
    }

    getName(): string {
        return 'PlayOddsUpfrontAct';
    }
}